import React from 'react';
import { useSelector } from 'react-redux';
import { getAccountActivationStep } from 'redux/common/AccountActivationSlice';
import ActivationForm from './ActivationForm';
import ActivedSuccessfully from './ActivedSuccessfully';
import AlreadyActived from './AlreadyActived';
import ShouldRegister from './ShouldRegister';
import Agreement from './Agreement';

const ActivationStepFactory = () => {
  //
  const step = useSelector(getAccountActivationStep);

  const components: Record<typeof step, React.ReactElement> = {
    Agreement: <Agreement />,
    SendingRequest: <ActivationForm />,
    ActivedSuccessfully: <ActivedSuccessfully />,
    AlreadyActived: <AlreadyActived />,
    ShouldRegister: <ShouldRegister />,
  };

  return components[step];
};

export default ActivationStepFactory;
